"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformProps = exports.shouldToggleAccordionItem = void 0;
var _excluded = ["onExpand", "onCollapse"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var validateProps = function validateProps(panelLeftSectionProps, panelRightSectionProps, panelMiddleSectionProps, bodyProps) {
  var bodyPropsLength = bodyProps.length;
  var propsToValidate = [{
    name: 'panelMiddleSectionProps',
    size: panelMiddleSectionProps.length
  }, {
    name: 'bodyProps',
    size: bodyPropsLength
  }];
  if (Array.isArray(panelLeftSectionProps)) {
    propsToValidate.push({
      name: 'panelLeftSectionProps',
      size: panelLeftSectionProps.length
    });
  }
  if (Array.isArray(panelRightSectionProps)) {
    propsToValidate.push({
      name: 'panelRightSectionProps',
      size: panelRightSectionProps.length
    });
  }
  var arePropsValid = true;
  propsToValidate.forEach(function (prop) {
    if (bodyPropsLength !== prop.size) {
      arePropsValid = false;
      return false;
    }
    return true;
  });
  if (!arePropsValid) {
    var propNames = '';
    var propsSizes = '';
    propsToValidate.forEach(function (prop, i) {
      if (propsToValidate.length - 1 !== i) {
        propNames += "'".concat(prop.name, "', ");
      } else {
        propNames += "and '".concat(prop.name, "'");
      }
      propsSizes += "\nLength of '".concat(prop.name, "' is ").concat(prop.size);
    });
    throw new Error("Mismatch in accordion props length. Arrays: ".concat(propNames, " must have the same length. ").concat(propsSizes));
  }
};
var toArray = function toArray(item, length) {
  if (Array.isArray(item)) {
    return item;
  }
  return _toConsumableArray(Array(length).keys()).fill(item);
};
var transformProps = exports.transformProps = function transformProps(_ref) {
  var styles = _ref.styles,
    panelLeftSectionProps = _ref.panelLeftSectionProps,
    panelRightSectionProps = _ref.panelRightSectionProps,
    panelMiddleSectionProps = _ref.panelMiddleSectionProps,
    bodyProps = _ref.bodyProps;
  validateProps(panelLeftSectionProps, panelRightSectionProps, panelMiddleSectionProps, bodyProps);
  var bodyPropsLength = bodyProps.length;
  var leftSectionProps = toArray(panelLeftSectionProps, bodyPropsLength);
  var rightSectionProps = toArray(panelRightSectionProps, bodyPropsLength);
  return bodyProps.map(function (bodyProp, key) {
    var onExpand = bodyProp.onExpand,
      onCollapse = bodyProp.onCollapse,
      remainingBodyProps = _objectWithoutProperties(bodyProp, _excluded);
    return {
      key: key,
      remainingBodyProps: remainingBodyProps,
      styles: styles,
      leftSectionProp: leftSectionProps[key],
      rightSectionProp: rightSectionProps[key],
      middleSectionProp: panelMiddleSectionProps[key],
      onExpand: onExpand,
      onCollapse: onCollapse
    };
  });
};
var shouldToggleAccordionItem = exports.shouldToggleAccordionItem = function shouldToggleAccordionItem(indexes, index) {
  var normalizedIndexes = indexes;
  if (typeof indexes === 'number') {
    normalizedIndexes = [indexes];
  }
  if (Array.isArray(normalizedIndexes)) {
    return normalizedIndexes.includes(index);
  }
  return false;
};